import { Component, HostListener, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Event, Router, NavigationStart, NavigationEnd, ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';
import { environment } from '../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { SpinnerService } from './all-modules/shared/services/spinner.service';
import { PushNotificationsService } from './all-modules/shared/services/push-notifications.service';
import { AuthService } from './all-modules/core/service/auth.service';
import { CommonService } from './all-modules/shared/services/common.service';
import { tuiNumberFormatProvider } from '@taiga-ui/core';
import { TuiDayOfWeek, TuiDay, TuiDayRange, TuiDateMode } from '@taiga-ui/cdk';
import { TuiPushService } from '@taiga-ui/kit';
import { switchMap, take } from 'rxjs/operators';
import { APP_CONSTANTS } from "./all-modules/shared/constants/constant";
import { interval, firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [
    ToastrService,
    tuiNumberFormatProvider({
      decimalSeparator: '.',
      thousandSeparator: ',',
    }),
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AppComponent implements OnInit {
  currentUrl!: string;
  title = 'af-notification';
  appName = APP_CONSTANTS.APP_TITLE;
  message: any = null;
  isLoading = false;
  count = 0;
  private currentBuild = '';

  constructor(
    public _router: Router,
    private authService: AuthService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    public commonService: CommonService,
    public spinnerService: SpinnerService,
    private titleService: Title,
    private http: HttpClient,
    @Inject(TuiPushService) protected readonly push: TuiPushService
  ) {
    this._router.events.subscribe((routerEvent: any) => {
      if (routerEvent instanceof NavigationStart) {
        this.currentUrl = routerEvent.url.substring(
          routerEvent.url.lastIndexOf('/') + 1
        );
        const browserRefresh = !_router.navigated;

        if (browserRefresh && this.authService.currentUserValue.success) {
          this.commonService.GetLoggedInUserDetails();
          this.authService.refreshToken();
        }
      }
      if (routerEvent instanceof NavigationEnd) {
        //
      }
      if (routerEvent.url) {
        if (routerEvent.url.substring(0, 10) !== '/so/update') {
          window.scrollTo(0, 0);
        }
      }
    });
  }
  private async fetchBuild(): Promise<string> {
    try {
      const url = `/assets/version.json?v=${Date.now()}`;
      const v: any = await firstValueFrom(this.http.get(url));
      return v?.build ?? '';
    } catch {
      return '';
    }
  }

  async ngOnInit(): Promise<void> {
    //this.requestPermission();
    //this.listen();
    this.titleService.setTitle(this.appName);
    this.currentBuild = await this.fetchBuild();

    interval(5 * 60 * 1000).subscribe(async () => { // every 5 min
      const latest = await this.fetchBuild();
      if (latest && latest !== this.currentBuild) {
        // show banner/toast OR hard reload
        location.reload();
      }
    });
  }



  // @HostListener('document:mousemove', ['$event'])
  // onMouseMove(event: MouseEvent) {
  //   console.log(event);
  //   this.count++;
  // }

  // requestPermission() {
  //   Notification.requestPermission().then((permission) => {
  //     if (permission === 'granted') {
  //       console.log('Notification permission granted.');
  //     } else {
  //       console.log('Notification permission NOT granted.');
  //     }
  //   });
  //   const messaging = getMessaging();
  //   getToken(messaging,
  //     {vapidKey: environment.firebase.vapidKey}).then(
  //     (currentToken) => {
  //       if (currentToken) {
  //         console.log("Hurraaa!!! we got the token.....");
  //         console.log(currentToken);
  //       } else {
  //         console.log('No registration token available. Request permission to generate one.');
  //       }
  //     }).catch((err) => {
  //     console.log('An error occurred while retrieving token. ', err);
  //   });
  // }

  // listen() {
  //   const messaging = getMessaging();
  //   //console.log(messaging);
  //   onMessage(messaging, (payload) => {
  //     // console.log('message received');
  //     // console.log(messaging);
  //     //this.showInfo(payload?.notification?.title, payload?.notification?.body);
  //     this.message = payload;
  //     this.push
  //       .open(payload?.notification?.body, {
  //         heading: payload?.notification?.title,
  //         type: 'Show Management Event',
  //         icon: '@tui.check-square',
  //         buttons: ['Show me details', 'Close']
  //       })
  //       .pipe(
  //         take(1),
  //         switchMap(button => this.alert.open(button)),
  //       )
  //       .subscribe();
  //   });

  //   //messaging.onTokenRefresh = _messaging.onTokenRefresh.bind(_messaging);
  // }

  showInfo(title: any, msg: any) {
    this.toastr.info(title, msg, {
      progressBar: true,
      timeOut: 10000,
    });
  }

  // onClose(): void {
  //   this.alert
  //     .open('Close button is visible when you subscribe to (close) output')
  //     .subscribe();
  // }
}
